<template>
  <section id="igPost">
    <div class="elfsight-app-561b4294-d8e5-45df-acfe-139f37255313"></div>
  </section>
</template>
<script>
export default {
  name: "IgPost"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#eapps-instagram-feed-1,
#eapps-instagram-feed-2 {
  margin: 0 auto;
}
</style>
